


import React, { useState } from "react";

const gallery = [

  { id: 4, name: "", image: "/images/fleets/1.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/2.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/3.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/4.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/5.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/6.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/7.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/8.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/9.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/10.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/11.jpeg" },  
  { id: 4, name: "", image: "/images/fleets/12.jpeg" },  
  
  
  { id: 4, name: "Dzire", image: "/images/fleets/Dzire.jpg" },         
  { id: 1, name: "Aura", image: "/images/fleets/aura.jpg" },            
  { id: 7, name: "Kia", image: "/images/fleets/kia.jpg" },            
  { id: 5, name: "Ertiga", image: "/images/fleets/Ertiga.jpg" },       
  { id: 3, name: "Crysta", image: "/images/fleets/crysta.jpg" },       
  { id: 6, name: "Innova", image: "/images/fleets/innova.jpg" },       
  { id: 18, name: "Urbania", image: "/images/fleets/urbania.jpg" },    
  { id: 17, name: "Tempo Traveller", image: "/images/fleets/tempo-traveller.jpg" },
  { id: 2, name: "Bus", image: "/images/fleets/bus.jpg" }             

];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
      <div className="breadcrumb-bar text-center">
        <h2 className="text-white">Gallery</h2>
      </div>

      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4">
              <div className="gallery-card borderr" onClick={() => openImage(index)}>
                <img src={item.image} alt={item.name} />
                <h5>{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;